import React, { useEffect, useState } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import useSessionStore from "../store/useSessionStore";
import classNames from "classnames";

const Admin = () => {
  const navigate = useNavigate();
  const { user } = useSessionStore();
  const [selectedMenu, setSelectedMenu] = useState("/");

  const menuItems = [
    { name: "Dashboard", route: "/admin" },
    { name: "Institución", route: "/admin/institution" },
    { name: "Super Poderes", route: "/admin/super-power" },
    { name: "Perfil de Clase", route: "/admin/class-profile" },
    // Añade aquí más rutas según necesites
  ];

  const handleMenuItemClick = (route) => {
    setSelectedMenu(route);
    navigate(route); // Esto cambiará la URL y renderizará el componente vinculado a la ruta
  };

  useEffect(() => {
    if (user && !user?.role?.length) {
      navigate("/");
    }
    if (user && user?.role?.length) {
      const findAdmin = user.role.some((e) => e.slug === "admin");
      if (!findAdmin) {
        navigate("/");
      }
    }
    // eslint-disable-next-line
  }, [user]);

  return (
    <div className="flex h-screen w-full bg-gray-100 justify-around ">
      {/* Sidebar */}
      <div className="w-64 bg-DarkBlue-900 text-white p-6 space-y-2">
        {menuItems.map((item) => (
          <button
            key={item.route}
            className={classNames(
              "block text-left w-full py-2 px-4 rounded transition-colors duration-200",
              { "bg-DarkBlue-700": selectedMenu === item.route },
              { "hover:bg-DarkBlue-700": selectedMenu !== item.route }
            )}
            onClick={() => handleMenuItemClick(item.route)}
          >
            {item.name}
          </button>
        ))}
      </div>

      {/* Contenido Principal */}
      <div className="flex-1 overflow-auto w-full mb-10">
        <Outlet />{" "}
        {/* Este componente renderizará el contenido de la ruta seleccionada */}
      </div>
    </div>
  );
};

export default Admin;
